import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Problems } from "@/components/Problems";
import { Value } from "@/components/Value";
import { Benefits } from "@/components/Benefits";
import { Program } from "@/components/Program";
import { ForWhom } from "@/components/ForWhom";
import { Trainers } from "@/components/Trainers";
import { Reviews } from "@/components/Reviews";
import { Platform } from "@/components/Platform";
import { Pricing } from "@/components/Pricing";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { FinalCta } from "@/components/FinalCta";
import { StickyMobileCta } from "@/components/StickyMobileCta";
import { ThankYou } from "@/components/ThankYou";

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            {window.location.pathname.startsWith("/dziekuje") ? (
                <ThankYou />
            ) : (
                <>
                    <Header />
                    <main className="pb-24 lg:pb-0">
                <Hero />
                <Marquee />
                <Problems />
                <Value />
                <Benefits />
                <Program />
                <ForWhom />
                <Trainers />
                <Reviews />
                <Platform />
                <Pricing />
                <Faq />
                <Contact />
                        <FinalCta />
                    </main>
                    <StickyMobileCta />
                </>
            )}
        </div>
    );
}

export default App;
